module.exports = __webpack_public_path__ + "static/media/socialmedia-services-img1.5b6039ee.jpg";